import React, {Component, Fragment} from 'react';
import style from '../css/complexButton.css';
import {connect} from 'react-redux';
import {TRICAST} from '../constants/identifiers';
import Button from "../../../components/button";
import {toggleMultiBetRacerSelection} from '../actions/raceCardActions';
import {getText} from "../../../../../helpers/localization";

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedEventMultiBetList: state.vpp.selectedEventMultiBetList,
        selectedRacingBetType: state.vpp.selectedRacingBetType,
        selectedOddsType: state.vpp.selectedOddsType,
        systemLanguage: state.vpp.systemLanguage
    };
};

class ComplexButton extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            events: storeData.vpp.events,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedEventMultiBetList: storeData.vpp.selectedEventMultiBetList,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            selectedOddsType: storeData.vpp.selectedOddsType,
            systemLanguage: storeData.vpp.systemLanguage
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState(
                {
                    events: storeData.vpp.events,
                    selectedEventIndex: storeData.vpp.selectedEventIndex,
                    selectedEventMultiBetList: storeData.vpp.selectedEventMultiBetList,
                    selectedRacingBetType: storeData.vpp.selectedRacingBetType,
                    selectedOddsType: storeData.vpp.selectedOddsType,
                    systemLanguage: storeData.vpp.systemLanguage
                }
            );
        }
    }

    render() {
        return (
            <Fragment>
                <Button
                    store={this.props.store}
                    htmlId={this.props.racer.num + '_1st'}
                    style={style.checkContainer}
                    sbLabel={getText('FIRST_ST', this.props.store)}
                    complexBet={true}
                    sbSub={getText('ST', this.props.store)}
                    circleSize={this.props.circleSize}
                    isChecked={this._isCheckedInPosition(0)}
                    isEnabled={this._isEnableInPosition(0)}
                    callback={() => this._click(0)}/>
                <Button
                    store={this.props.store}
                    htmlId={this.props.racer.num + '_2nd'}
                    style={style.checkContainer}
                    sbLabel={getText('SECOND_ND', this.props.store)}
                    complexBet={true}
                    sbSub={getText('ND', this.props.store)}
                    circleSize={this.props.circleSize}
                    isChecked={this._isCheckedInPosition(1)}
                    isEnabled={this._isEnableInPosition(1)}
                    callback={() => this._click(1)}/>

                {
                    this.props.selectedRacingBetType === TRICAST
                        ? <Button
                            store={this.props.store}
                            htmlId={this.props.racer.num + '_3rd'}
                            style={style.checkContainer}
                            sbLabel={getText('THIRD_RD', this.props.store)}
                            complexBet={true}
                            sbSub={getText('RD', this.props.store)}
                            circleSize={this.props.circleSize}
                            isChecked={this._isCheckedInPosition(2)}
                            isEnabled={this._isEnableInPosition(2)}
                            callback={() => this._click(2)}/>
                        : ''
                }
                <Button
                    store={this.props.store}
                    style={style.checkContainer}
                    htmlId={this.props.racer.num + '_any'}
                    sbLabel={getText('Any', this.props.store)}
                    complexBet={true}
                    sbSub={''}
                    buttonStyle={style.textAny}
                    circleSize={this.props.circleSize}
                    isChecked={this._isCheckedInPosition(3)}
                    isEnabled={this._isAnyButtonEnabled()}
                    callback={() => this._click(3)}/>
            </Fragment>
        );
    }

    _isEnableInPosition(buttonPosition) {
        let selectedPositions = this.state.selectedEventMultiBetList.slice();

        //if ANY position mode selected  -> disable  all position buttons
        if (this._isANYButtonSelected(selectedPositions)) {
            return false;
        }
        //If a position is already selected for the racer from 1st to 3rd -> others positions should be disabled for the racer.
        for (let position = 0; position < selectedPositions.length - 1; position++) {
            if (this._isRacerPositionAlreadySelected(selectedPositions, position) && position !== buttonPosition) {
                return false;
            }
        }
        //If a position is not selected for any racer -> position should be enabled for the racer
        //If a position is already selected for the racer from 1st to 3rd -> that position should be enabled for the racer.
        if (this._isPositionNotSelectedForAnyRacer(selectedPositions, buttonPosition) || (this._isRacerPositionAlreadySelected(selectedPositions, buttonPosition))) {
            return true;
        } else {
            return false;
        }
    }

    _isANYButtonSelected(selectedPositions) {
        return selectedPositions[selectedPositions.length - 1].length > 0;
    }

    _isRacerPositionAlreadySelected(selectedPositions, position) {
        return selectedPositions[position] && selectedPositions[position].name === this.props.racer.name && selectedPositions[position].num === this.props.racer.num;
    }

    _isPositionNotSelectedForAnyRacer(selectedPositions, position) {
        return selectedPositions[position] === undefined;
    }

    _isAnyButtonEnabled() {
        let auxSelectedEventMultiBetList = this.state.selectedEventMultiBetList;
        //disable ANY buttons if positions 1,2 or 3 selected
        for (let i = 0; i < auxSelectedEventMultiBetList.length - 1; i++) {
            if (auxSelectedEventMultiBetList[i]) {
                return false;
            }
        }
        if (auxSelectedEventMultiBetList[3] !== undefined) {
            //enable Any button for Any selected
            let racerInListOfAny = auxSelectedEventMultiBetList[3].find(racer => racer.name === this.props.racer.name && racer.num === this.props.racer.num);
            if (racerInListOfAny !== undefined) {
                return true;
            }
            //disable All other Any buttons if all positions choosen
            if (this.props.selectedRacingBetType === TRICAST) {
                return auxSelectedEventMultiBetList[3].length < 3;
            } else {
                return (auxSelectedEventMultiBetList[3].length < 2);
            }
        }
    }

    _isCheckedInPosition(position) {
        let auxSelectedEventMultiBetList = this.state.selectedEventMultiBetList;
        if (position < auxSelectedEventMultiBetList.length - 1) {
            if (auxSelectedEventMultiBetList[position] && auxSelectedEventMultiBetList[position].name === this.props.racer.name && auxSelectedEventMultiBetList[position].num === this.props.racer.num) {
                return true;
            }
        } else {
            let racerInListOfAny = auxSelectedEventMultiBetList[position].find(racer => racer.name === this.props.racer.name && racer.num === this.props.racer.num);
            if (racerInListOfAny !== undefined) {
                return true;
            }
        }
        return false;
    }

    _click(place) {
        this._enableAnimation();
        this.props.store.dispatch(toggleMultiBetRacerSelection(place, this.props.racer));
    }

    _enableAnimation() {
    }

}

export default connect(mapStateToProps)(ComplexButton);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/components/complexButton.js